import http from "../http-common";

const getAll = (customerId) => {
  const params = {};
  if (customerId) params.customerId = customerId;
  return http.get("/customer-absenses", { params });
};

const create = (data) => {
  return http.post("/customer-absenses", data);
};

const remove = (id) => {
  return http.delete(`/customer-absenses/${id}`);
};

const clearDayOverrides = (customerId, date) => {
  return http.post("/customer-absenses/clear-day-overrides", {
    customer_id: customerId,
    date,
  });
};

export const CustomerAbsenseService = {
  getAll,
  create,
  remove,
  clearDayOverrides,
};
